import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from 'react';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';

type Props = {
  children: ReactNode;
};

type DisplayType = 'list' | 'kanban';

export type ApprovalSearchCondition = {
  identifier: string;
  user_ids: number[];
  business_partner_ids: number[];
  team_ids: number[];
  enabled: boolean;
};
export const defaultApprovalSearchCondition: ApprovalSearchCondition = {
  identifier: '',
  user_ids: [],
  business_partner_ids: [],
  team_ids: [],
  enabled: false,
};

export type ApprovalSearchConditionType = {
  approvalDisplayType: DisplayType;
  setApprovalDisplayType: Dispatch<SetStateAction<DisplayType>>;
  approvalSearchCondition: ApprovalSearchCondition;
  setApprovalSearchCondition: Dispatch<SetStateAction<ApprovalSearchCondition>>;
};

export const ApprovalSearchConditionContext = createContext<ApprovalSearchConditionType>({
  approvalDisplayType: 'list',
  setApprovalDisplayType: () => {},
  approvalSearchCondition: defaultApprovalSearchCondition,
  setApprovalSearchCondition: () => {},
});

export const ApprovalSearchConditionProvider = ({ children }: Props) => {
  const { _w_ } = useCurrentWorkspace();

  const [approvalDisplayType, setApprovalDisplayType] = useState<DisplayType>('list');
  const [approvalSearchCondition, setApprovalSearchCondition] = useState<ApprovalSearchCondition>(defaultApprovalSearchCondition);

  useEffect(() => {
    if (_w_) setApprovalSearchCondition((c) => ({ ...c, identifier: _w_!.identifier }));
  }, [_w_]);

  return (
    <ApprovalSearchConditionContext.Provider
      value={{
        approvalDisplayType,
        setApprovalDisplayType,
        approvalSearchCondition,
        setApprovalSearchCondition,
      }}
    >
      {children}
    </ApprovalSearchConditionContext.Provider>
  );
};

export const useApprovalSearchCondition = () => {
  return useContext(ApprovalSearchConditionContext);
};
